import React from 'react';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { getAccessToken, Toast } from '../../utils/helper';
import {
    GET_BANNERS,
    GET_DASHBOARD_DETAILS,
    GET_INCBOT_INTERVIEW_MONTHLY_STATS,
    GET_DASHBOARD_INTERVIEWS,
    GET_FINAL_OUTCOMES,
    GET_FEEDBACK_STATUS,
    GET_POSITIONS_SUMMARY,
    GET_TOP_POSITIONS,
    GET_POSITION_ANALYTICS,
    GET_INTERVIEW_COMPLETED,
    GET_TOTAL_INTERVIEWS,
    GET_INTERVIEW_COMPLETED_SUMMARY,
    GET_WHATS_NEW,
    GET_DASHBOARD_USER_POSITIONS,
    GET_DASHBOARD_SUBUSER_LIST,
} from '../action/types';
import {
    getDashboardDetailsSuccess,
    getDashboardDetailsFailure,
    getBannersSuccess,
    getBannersFailure,
    getIncbotInterviewMonthlyStatsSuccess,
    getIncbotInterviewMonthlyStatsFailure,
    getDashboardInterviewsSuccess,
    getDashboardInterviewsFailure,
    getFinalOutcomesSuccess,
    getFinalOutcomesFailure,
    getFeedbackStatusSuccess,
    getFeedbackStatusFailure,
    getPositionsSummaryFailure,
    getPositionsSummarySuccess,
    getTopPositionsSuccess,
    getTopPositionsFailure,
    getPositionAnalyticsFailure,
    getPositionAnalyticsSuccess,
    getInterviewCompletedFailure,
    getInterviewCompletedSuccess,
    getTotalInteviewsSuccess,
    getTotalInterviewsFailure,
    getInterviewCompletedSummaryFailure,
    getInterviewCompletedSummarySuccess,
    getWhatsNewSuccess,
    getWhatsNewFailure,
    getDashboardUserPositionsSuccess,
    getDashboardUserPositionsFailure,
    getDashboardSubuserListSuccess,
    getDashboardSubuserListFailure,
} from '../action';
import INTERVIEW from '../../utils/api/interview';
import USERS from '../../utils/api/users';
import LOCAL_TEST from '../../utils/api/localTest';
function* getDashboardDetailsRequest(action) {
    try {
        const { payload } = action;
        const positionInterviewId = payload?.positionInterviewId || '';
        const positionRatingId = payload?.positionRatingId || '';
        const queryParams = `${
            positionInterviewId ? `positionInterviewId=${positionInterviewId}` : ''
        }${positionRatingId ? `&positionRatingId=${positionRatingId}` : ''}`;
        const endpoint = `incbot/dashboardStats?${queryParams}`;
        const res = yield INTERVIEW.get(endpoint);
        if (res.status === 201 || res.status === 200) {
            yield put(getDashboardDetailsSuccess(res.data.result));
        }
    } catch (e) {
        yield put(getDashboardDetailsFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}
function* getBannersRequest() {
    try {
        const res = yield USERS.get('employers/getBanners');
        if (res.status === 201 || res.status === 200) {
            yield put(getBannersSuccess(res.data.result));
        } else yield put(getBannersFailure());
    } catch (e) {
        yield put(getBannersFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}
function* getIncbotInterviewMonthlyStatsRequest(action) {
    try {
        const res = yield INTERVIEW.post(`interviews/interview-stats-monthwise`, {
            productId: action.payload.productId,
        });
        if (res.status === 200 || res.status === 201) {
            yield put(getIncbotInterviewMonthlyStatsSuccess(res.data.result));
        }
    } catch (e) {
        yield put(getIncbotInterviewMonthlyStatsFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, { toastId: e?.response?.data?.message });
    }
}
export function* watchGetDashboardDetailsAPI() {
    yield takeEvery(GET_DASHBOARD_DETAILS, getDashboardDetailsRequest);
}
export function* watchGetBannersAPI() {
    yield takeEvery(GET_BANNERS, getBannersRequest);
}

export function* watchGetIncbotInterviewMonthlyStatsAPI() {
    yield takeEvery(GET_INCBOT_INTERVIEW_MONTHLY_STATS, getIncbotInterviewMonthlyStatsRequest);
}

function* getDashboardInterviewsRequest(action) {
    try {
        const { payload } = action;
        const userId = payload?.userId || '';
        const body = {};

        // userId can be a single string or an array
        if (Array.isArray(userId)) {
            const filtered = userId.filter(Boolean);
            if (filtered.length) body.createdBy = filtered;
        } else if (userId && userId !== 'all') {
            body.createdBy = userId;
        }
        if (payload?.month) body.month = payload.month;
        if (payload?.view && ['day', 'week', 'month'].includes(payload.view)) body.view = payload.view;
        if (payload?.status) body.status = payload.status;
        if (payload?.from) body.from = payload.from;
        if (payload?.to) body.to = payload.to;
        if (payload?.position?.length) body.position = payload.position.filter(Boolean);
        if (payload?.recruiter?.length) body.recruiter = payload.recruiter.filter(Boolean);

        const res = yield INTERVIEW.post('incbot/dashboard/interviews', body);
        if (res.status === 200 || res.status === 201) {
            const interview = res.data.result?.interview || null;
            const chartData = res.data.result?.chartData || [];
            const payloadToStore = interview ? { ...interview, chartData } : null;
            yield put(getDashboardInterviewsSuccess(payloadToStore));
        }
    } catch (e) {
        yield put(getDashboardInterviewsFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetDashboardInterviewsAPI() {
    yield takeEvery(GET_DASHBOARD_INTERVIEWS, getDashboardInterviewsRequest);
}

function* getFinalOutcomesRequest(action) {
    try {
        const { payload } = action;
        const body = {};
        if (payload?.userId) body.userId = payload.userId;
        if (payload?.from) body.from = payload.from;
        if (payload?.to) body.to = payload.to;
        if (payload?.position?.length) body.position = payload.position.filter(Boolean);
        if (payload?.recruiter?.length) body.recruiter = payload.recruiter.filter(Boolean);

        const res = yield INTERVIEW.post('incbot/dashboard/final-outcomes', body);
        if (res.status === 200 || res.status === 201) {
            yield put(getFinalOutcomesSuccess(res.data.result || null));
        }
    } catch (e) {
        yield put(getFinalOutcomesFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetFinalOutcomesAPI() {
    yield takeEvery(GET_FINAL_OUTCOMES, getFinalOutcomesRequest);
}

function* getFeedbackStatusRequest(action) {
    try {
        const { payload } = action;
        const body = {};
        if (payload?.from) body.from = payload.from;
        if (payload?.to) body.to = payload.to;
        if (payload?.position?.length) body.position = payload.position.filter(Boolean);
        if (payload?.recruiter?.length) body.recruiter = payload.recruiter.filter(Boolean);

        const res = yield INTERVIEW.post('incbot/dashboard/feedback', body);
        if (res.status === 200 || res.status === 201) {
            yield put(getFeedbackStatusSuccess(res.data.result || null));
        }
    } catch (e) {
        yield put(getFeedbackStatusFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetFeedbackStatusAPI() {
    yield takeEvery(GET_FEEDBACK_STATUS, getFeedbackStatusRequest);
}
function* getPositionsSummaryRequest(action) {
    try {
        const { payload } = action;
        const month = payload?.month || '';
        let queryParams = [];
        if (month) {
            queryParams.push(`month=${month}`);
        }
        const endpoint = `incbot/dashboard/positions${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`;
        const res = yield INTERVIEW.get(endpoint);
        if (res.status === 200 || res.status === 201) {
            yield put(getPositionsSummarySuccess(res.data.result || null));
        }
    } catch (e) {
        yield put(getPositionsSummaryFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetPositionsSummaryAPI() {
    yield takeEvery(GET_POSITIONS_SUMMARY, getPositionsSummaryRequest);
}

export function* getTopPositionsRequest(action) {
    try {
        const { payload } = action;
        const body = {};
        if (payload?.from) body.from = payload.from;
        if (payload?.to) body.to = payload.to;
        if (payload?.position?.length) body.position = payload.position.filter(Boolean);
        if (payload?.recruiter?.length) body.recruiter = payload.recruiter.filter(Boolean);

        const res = yield INTERVIEW.post('incbot/topPositions', body);
        if (res.status === 200 || res.status === 201) {
            yield put(getTopPositionsSuccess(res.data.result || null));
        }
    } catch (e) {
        yield put(getTopPositionsFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetTopPositionsAPI() {
    yield takeEvery(GET_TOP_POSITIONS, getTopPositionsRequest);
}

export function* getPositionAnalyticsRequest(action) {
    try {
        const { payload } = action;
        const body = {};
        if (payload?.from) body.from = payload.from;
        if (payload?.to) body.to = payload.to;
        if (payload?.positionId) body.positionId = payload.positionId;
        if (payload?.month) body.month = payload.month;
        if (payload?.position?.length) body.position = payload.position.filter(Boolean);
        if (payload?.recruiter?.length) body.recruiter = payload.recruiter.filter(Boolean);

        const res = yield INTERVIEW.post('incbot/dashboard/positionAnalytics', body);
        if (res.status === 200 || res.status === 201) {
            yield put(getPositionAnalyticsSuccess(res.data.result || null));
        }
    } catch (e) {
        yield put(getPositionAnalyticsFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetPositionAnalyticsAPI() {
    yield takeEvery(GET_POSITION_ANALYTICS, getPositionAnalyticsRequest);
}

export function* getInterviewCompletedRequest(action) {
    try {
        const { payload } = action;
        const from = payload?.from || '';
        const to = payload?.to || '';
        const positionId = payload?.positionId || '';
        const month = payload?.month || '';
        let queryParams = [];
        if (from) {
            queryParams.push(`from=${from}`);
        }
        if (to) {
            queryParams.push(`to=${to}`);
        }
        if (positionId) {
            queryParams.push(`positionId=${positionId}`);
        }
        if (month) {
            queryParams.push(`month=${month}`);
        }
        const endpoint = `incbot/dashboard/interviewCompleted${queryParams.length > 0 ? `?${queryParams.join('&')}` : ''}`;
        const res = yield INTERVIEW.get(endpoint);
        if (res.status === 200 || res.status === 201) {
            yield put(getInterviewCompletedSuccess(res.data.result || null));
        }
    } catch (e) {
        yield put(getInterviewCompletedFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetInterviewCompletedAPI() {
    yield takeEvery(GET_INTERVIEW_COMPLETED, getInterviewCompletedRequest);
}

export function* getTotalInterviewsRequest(action) {
    try {
        const { payload } = action;
        const body = {};
        if (payload?.from) body.from = payload.from;
        if (payload?.to) body.to = payload.to;
        if (payload?.position?.length) body.position = payload.position.filter(Boolean);
        if (payload?.recruiter?.length) body.recruiter = payload.recruiter.filter(Boolean);

        const res = yield INTERVIEW.post('incbot/dashboard/interviewRecommended', body);
        if (res.status === 200 || res.status === 201) {
            yield put(getTotalInteviewsSuccess(res.data.result || null));
        }
    } catch (e) {
        yield put(getTotalInterviewsFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetTotalInterviewsAPI() {
    yield takeEvery(GET_TOTAL_INTERVIEWS, getTotalInterviewsRequest);
}

export function* getInterviewCompletedSummaryRequest(action) {
    try {
        const endpoint = 'incbot/dashboard/interviewCompletedsummary';
        const res = yield INTERVIEW.get(endpoint);
        if (res.status === 200 || res.status === 201) {
            yield put(getInterviewCompletedSummarySuccess(res.data.result || null));
        }
    } catch (e) {
        yield put(getInterviewCompletedSummaryFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetInterviewCompletedSummaryAPI() {
    yield takeEvery(GET_INTERVIEW_COMPLETED_SUMMARY, getInterviewCompletedSummaryRequest);
}

const extractWhatsNewPayload = (responseData) => {
    if (!responseData || typeof responseData !== 'object') return null;
    const payload =
        responseData?.result != null && typeof responseData.result === 'object' ? responseData.result : responseData;
    if (!payload || typeof payload !== 'object') return null;
    return payload;
};

function* getWhatsNewRequest(action) {
    try {
        const { productId } = action.payload || {};
        if (productId == null || productId === '') return;
        const res = yield USERS.get('/users/notifications/whats-new', {
            params: { productId },
        });
        if (res.status === 200 || res.status === 201) {
            const whatsNewData = extractWhatsNewPayload(res.data);
            yield put(getWhatsNewSuccess(whatsNewData));
            if (typeof action?.payload?.callback === 'function') {
                yield call(action.payload.callback, whatsNewData);
            }
        }
    } catch (e) {
        yield put(getWhatsNewFailure());
    }
}

export function* watchGetWhatsNewAPI() {
    yield takeEvery(GET_WHATS_NEW, getWhatsNewRequest);
}

function* getDashboardUserPositionsRequest() {
    try {
        const res = yield INTERVIEW.get('positions/userPositions');
        if (res.status === 200 || res.status === 201) {
            yield put(getDashboardUserPositionsSuccess(res.data.result || []));
        }
    } catch (e) {
        yield put(getDashboardUserPositionsFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetDashboardUserPositionsAPI() {
    yield takeEvery(GET_DASHBOARD_USER_POSITIONS, getDashboardUserPositionsRequest);
}

function* getDashboardSubuserListRequest() {
    try {
        const res = yield INTERVIEW.get('incbot/allSubuserList');
        if (res.status === 200 || res.status === 201) {
            yield put(getDashboardSubuserListSuccess(res.data.result || []));
        }
    } catch (e) {
        yield put(getDashboardSubuserListFailure());
        yield e?.response?.data?.message &&
            e?.response?.data?.message !== 'Your session has been expired, please login again!' &&
            toast.error(<Toast msg={e?.response?.data?.message} />, {
                autoClose: 5000,
                toastId: e?.response?.data?.message,
            });
    }
}

export function* watchGetDashboardSubuserListAPI() {
    yield takeEvery(GET_DASHBOARD_SUBUSER_LIST, getDashboardSubuserListRequest);
}

export default function* rootSaga() {
    yield all([
        watchGetDashboardDetailsAPI(),
        watchGetBannersAPI(),
        watchGetIncbotInterviewMonthlyStatsAPI(),
        watchGetDashboardInterviewsAPI(),
        watchGetFinalOutcomesAPI(),
        watchGetFeedbackStatusAPI(),
        watchGetPositionsSummaryAPI(),
        watchGetTopPositionsAPI(),
        watchGetPositionAnalyticsAPI(),
        watchGetInterviewCompletedAPI(),
        watchGetTotalInterviewsAPI(),
        watchGetInterviewCompletedSummaryAPI(),
        watchGetWhatsNewAPI(),
        watchGetDashboardUserPositionsAPI(),
        watchGetDashboardSubuserListAPI(),
    ]);
}
